var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTon = function SvgTon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ton_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0098EA",
    d: "M7.5 15a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.06 4.186H4.94a1.225 1.225 0 0 0-1.065 1.837l3.161 5.479a.537.537 0 0 0 .93 0l3.161-5.479c.473-.82-.123-1.837-1.065-1.837M7.034 9.859l-.689-1.332-1.661-2.971a.29.29 0 0 1 .255-.434h2.094V9.86zm3.282-4.304-1.66 2.972-.688 1.332V5.121h2.093a.29.29 0 0 1 .255.434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ton_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v15H0z"
  })))));
};
export default SvgTon;